import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { WebEnvironmentService } from '@degreed/lxp/services';
import { AuthService } from '@degreed/lxp/services/authorization';

// Environments not listed here deny everyone. Staging also allows 200007, the
// automation-testing org, so the automated suites can reach the ng-doc routes.
const AllowedOrgIds: Record<string, number[]> = {
  Production: [1],
  Staging: [1, 200007],
  LocalStaging: [1],
  Local: [1],
  Release: [1],
  Beta: [1],
};

@Injectable()
export class NgDocGuardService {
  private webEnvironmentService = inject(WebEnvironmentService);
  private router = inject(Router);
  private authService = inject(AuthService);

  public canMatch(): boolean | UrlTree {
    // Returning `false` would make the router fall through to the next matching
    // route, so redirect with a UrlTree instead to keep the error page behavior.
    return this.checkOrgMembership() ? true : this.router.parseUrl('/error');
  }

  public checkOrgMembership(): boolean {
    let isAllowed = false;
    const allowedOrgIds = AllowedOrgIds[this.webEnvironmentService.environment];

    // only allow for defined environments
    if (allowedOrgIds?.length) {
      const userOrgs: number[] = this.authService.authUser.orgInfo.map(
        (org) => org.organizationId
      );
      isAllowed = userOrgs.some((userOrgId) =>
        allowedOrgIds.includes(userOrgId)
      );
    }

    return isAllowed;
  }
}
